import { useEffect, useRef, useState } from 'react'

import type { NovoDestaque } from '@/features/reader/hooks/useHighlights'

export function SelectionNote({ target, onSave, onClose }: {
  target: NovoDestaque
  onSave: (entry: NovoDestaque) => void | Promise<unknown>
  onClose: () => void
}) {
  const [note, setNote] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(false)
  const input = useRef<HTMLTextAreaElement>(null)
  useEffect(() => { input.current?.focus() }, [])
  async function save() {
    setSaving(true); setError(false)
    try { await onSave({ ...target, note }); onClose() }
    catch { setError(true) }
    finally { setSaving(false) }
  }
  return <form className="reader-study-tool" aria-label="Anotar trecho" onSubmit={event => {
    event.preventDefault(); void save()
  }}>
    <h2>Anotação na página {target.page}</h2>
    <blockquote>{target.text_content}</blockquote>
    <label htmlFor="selection-note">Minha anotação</label>
    <textarea id="selection-note" ref={input} required maxLength={5000} value={note}
      disabled={saving} onChange={event => setNote(event.target.value)} />
    <button type="submit" disabled={saving || !note.trim()}>{saving ? 'Salvando…' : 'Salvar anotação'}</button>
    <button type="button" disabled={saving} onClick={onClose}>Cancelar</button>
    {error && <p role="alert">Não foi possível salvar. Seu texto foi mantido; tente novamente.</p>}
  </form>
}
